import React, { useCallback, useContext, useState } from "react";
import { Button, Icon } from "@mui/material";

import { subscriptionService } from "@/features/subscriptions/services/subscriptionService";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { downloadFileAnchorTag } from "@/helpers/utils";
import { FILE_TYPE_MIME_TYPE, HTTP_STATUS } from "@/config/constants";

function DownloadUserSubscriptionDetail({ filters }) {
  const { loggedInUser } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);

  const getUserLocations = useCallback(
    async (data = {}) => {
      setLoading(true);
      try {
        const reqData = {
          ...filters,
          ...data,
          download: 1,
        };

        const res =
          await subscriptionService.getUserLocationsSubscriptionDetail(reqData);

        if (res.status === HTTP_STATUS.OK) {
          const blob = new Blob([res.data], {
            type: FILE_TYPE_MIME_TYPE.xlsx,
          });
          const objectUrl = URL.createObjectURL(blob);
          //window.open(objectUrl);

          const fileName = `${loggedInUser.first_name}_${
            loggedInUser.last_name
          }-user-${
            loggedInUser.id
          }-subscription-detail-${new Date().toLocaleDateString()}.xlsx`;

          downloadFileAnchorTag(objectUrl, fileName);
        }
      } catch (err: any) {
        if (err?.__CANCEL__) {
          setTimeout(() => {
            setLoading(true);
          }, 100);
        }
      } finally {
        setLoading(false);
      }
    },
    [filters, loggedInUser]
  );

  return (
    <div>
      <Button
        variant="outlined"
        onClick={() => getUserLocations()}
        startIcon={<Icon>download</Icon>}
        fullWidth
        disableElevation
      >
        {loading ? "Downloading.." : "Download"}
      </Button>
    </div>
  );
}

export default DownloadUserSubscriptionDetail;
